<template>
  <img src="/reg_back.png" alt="Вход"/>
</template>

<script>
export default {
  name: 'RegBack'
}
</script>
